var Highcharts = require('highcharts/highcharts');

export class OptNowEnrollmentPage {
    enrollmentData: any;
    hospitalStayData: any;
	constructor(enrollmentData: any, hospitalStayData: any) {
        this.enrollmentData = enrollmentData;
        this.hospitalStayData = hospitalStayData;
        $(() => {
            var opt_sites = [{ 'siten': 101, 'site': 'University of Arkansas for Medical Sciences', 'ast': 'Finnegan', 'Dosing Approach': 'Symptom-Based' },
            { 'siten': 103, 'site': 'Thomas Jefferson University', 'ast': 'Finnegan', 'Dosing Approach': 'Symptom-Based' },
            { 'siten': 104, 'site': 'University of Louisville Hospital', 'ast': 'Finnegan', 'Dosing Approach': 'Symptom-Based' },
            { 'siten': 105, 'site': 'University of Alabama at Birmingham', 'ast': 'Finnegan', 'Dosing Approach': 'Scheduled Opioid Taper' },
            { 'siten': 106, 'site': 'Indiana University - Eskenazi Hospital', 'ast': 'Finnegan', 'Dosing Approach': 'Scheduled Opioid Taper' },
            { 'siten': 107, 'site': 'University of Kansas', 'ast': 'ESC', 'Dosing Approach': 'Symptom-Based' },
            { 'siten': 108, 'site': 'University of Kentucky', 'ast': 'Finnegan', 'Dosing Approach': 'Scheduled Opioid Taper' },
            { 'siten': 109, 'site': "Norton Women's and Children's Hospital", 'ast': 'Finnegan', 'Dosing Approach': 'Symptom-Based' },
            { 'siten': 110, 'site': "Norton Children's Hospital", 'ast': 'ESC', 'Dosing Approach': 'Scheduled Opioid Taper' },
            { 'siten': 111, 'site': "Oklahoma Children's Hospital", 'ast': 'ESC', 'Dosing Approach': 'Symptom-Based' },
            { 'siten': 112, 'site': 'ChristianaCare', 'ast': 'ESC', 'Dosing Approach': 'Scheduled Opioid Taper' },
            { 'siten': 202, 'site': 'University of Nebraska', 'ast': 'ESC', 'Dosing Approach': 'Symptom-Based' },
            { 'siten': 203, 'site': 'University of South Florida - Tampa', 'ast': 'ESC', 'Dosing Approach': 'Scheduled Opioid Taper' },
            { 'siten': 204, 'site': 'Good Samaritan Hospital', 'ast': 'ESC', 'Dosing Approach': 'Symptom-Based' },
            { 'siten': 205, 'site': 'Hospital of the University of Pennsylvania (HUP)', 'ast': 'ESC', 'Dosing Approach': 'Scheduled Opioid Taper' },
            { 'siten': 209, 'site': 'Pennsylvania Hospital (PAH)', 'ast': 'ESC', 'Dosing Approach': 'Symptom-Based' },
            { 'siten': 210, 'site': 'AtlantiCare', 'ast': 'ESC', 'Dosing Approach': 'Symptom-Based' },
            { 'siten': 213, 'site': "University of Cincinnati Children's Hospital", 'ast': 'ESC', 'Dosing Approach': 'Scheduled Opioid Taper' },
            { 'siten': 215, 'site': 'University of New Mexico', 'ast': 'ESC', 'Dosing Approach': 'Symptom-Based' },
            { 'siten': 216, 'site': 'University of Rochester', 'ast': 'ESC', 'Dosing Approach': 'Scheduled Opioid Taper' },
            { 'siten': 217, 'site': 'University of Utah', 'ast': 'ESC', 'Dosing Approach': 'Scheduled Opioid Taper' },
            { 'siten': 303, 'site': 'St. Elizabeth Healthcare', 'ast': 'ESC', 'Dosing Approach': 'Symptom-Based' },
                { 'siten': 310, 'site': 'Kettering Health', 'ast': 'Finnegan', 'Dosing Approach': 'Scheduled Opioid Taper' }];

            // create an array of opt_sites with a new period property. Make it have periods 1 and 2
                var opt_sites2 = opt_sites.map(site => {
					return { ...site, period: 1 }
				}).concat(opt_sites.map(site => {
					return { ...site, period: 2 }
				}));

       

            var bar_colors = { 'ESC1': '#532565', 'ESC2': '#982568', 'Finnegan1': '#981f32', 'Finnegan2': '#818a91' };
            var dosing_colors = { 'Scheduled Opioid Taper': '#532565', 'Symptom-Based': '#982568' };
            // console.log(Object.values(bar_colors))

            // official colors
            var off_colors = {
                'Purple': '#532565',
                'Magenta': '#982568',
                'Red': '#981f32',
                'Coral': '#e07c3e',
                'Orange': '#bf362e',
                'Purple-Tint': '#c0b3c5',
                'Magenta-Tint': '#dabeca',
                'Red-Tint': '#dbb9b3',
                'Coral-Tint': '#eecdcb',
                'Orange-Tint': '#f5d8c3'
            }

            // off_colors_alt = {
            //     'Purple':'#532565',    'Purple-Tint': '#c0b3c5',
            //     'Magenta':'#982568',   'Magenta-Tint': '#dabeca',
            //     'Red': '#981f32',      'Red-Tint': '#dbb9b3',
            //     'Coral': '#e07c3e',    'Coral-Tint': '#eecdcb',
            //     'Orange': '#bf362e',   'Orange-Tint': '#f5d8c3'
            // }


            // globally remove Highcharts watermark
            Highcharts.setOptions({ credits: { enabled: false } });

            Highcharts.setOptions({
                colors: ['#532565', '#982568', '#981f32', '#818a91', '#e07c3e', '#bf362e', '#dddddd']
            });



            // count by opt_sites from json
            var OPT_data = opt_sites2.map(siteObj => {
                var count = enrollmentData.filter(obj =>
                    obj.items.some(
                        item =>
                            obj.siteName === siteObj.site && 
                            obj.period === siteObj.period
                    )).length;
                return {
                    ...siteObj,
                    count: count
                };
            }).sort((a, b) => {
                return a.ast > b.ast ? 1 : a.ast < b.ast ? -1 : a.period > b.period ? 1 : a.period < b.period ? -1 : 0;
            });


            // Prepare data for the stacked barchart
            var OPT_enroll = ['ESC Period 1', 'ESC Period 2', 'Finnegan Period 1', 'Finnegan Period 2'].map(period => {
                return {
                    name: period,
                    data: opt_sites.map(siteObj => {
                        var periodNumber = period.includes('Period 1') ? 1 : 2;
                        var astType = period.includes('Finnegan') ? 'Finnegan' : 'ESC';
                        var siteData = OPT_data.find(data => data.site === siteObj.site && data.period === periodNumber && data.ast === astType);
                        return {
                            name: siteObj.site,
                            y: siteData ? siteData.count : 0
                        };
                    })
                };
            });

            // Highcharts stacked barchart
            Highcharts.chart('opt_barchart_1', {
                chart: { type: 'bar', height: 600 },
                title: { text: 'Enrollment by Assessment Approach' },
                xAxis: { categories: opt_sites.map(site => site.site), allowDecimals: false,  },
                yAxis: { title: { text: 'Count' }, allowDecimals: false },
                legend: {
                    enabled: true, labelFormatter: function () {
                        var total = 0;
                        for (var i = this.yData.length; i--;) { total += this.yData[i]; };
                        return this.name + ' - Total: ' + total;
                    }
                },
                plotOptions: {
                    series: {
                        stacking: 'normal',
                        borderWidth: 0,
                        dataLabels: {
                            enabled: true,
                            formatter: function () {
                                if (this.y) {
                                    return this.y;
                                }
                            }
                        }
                    }
                },
                series: OPT_enroll
            });
        




            // 2a - stacked barchart data
            const OPT_dosing: any[] = [...new Set(OPT_data.map((obj: any) => obj['Dosing Approach']))].map((x: any) => {
                return {
                    name: x,
                    data: Object.values(OPT_data.reduce((acc: any, obj: any) => {
                        if (!acc[obj.ast]) {
                            acc[obj.ast] = {};
                        }
                        if (!acc[obj.ast][obj['Dosing Approach']]) {
                            acc[obj.ast][obj['Dosing Approach']] = 0;
                        }
                        acc[obj.ast][obj['Dosing Approach']] += obj.count;
                        return acc;
                    }, {})).map((ast: any) => ast[x] || 0)
                };
            });

            // 2b - Highcharts stacked_barchart 
            Highcharts.chart('opt_barchart_2', {
                chart: { type: 'bar', borderWidth: 1, borderColor: '#000000' },
                title: { text: 'Enrollment by Assessment and Dosing Approach' },
                xAxis: {
                    categories: [...new Set(OPT_data.map((obj: any) => obj.ast))],
                    type: 'category',
                    allowDecimals: false
                },
                yAxis: { title: { text: 'Count' }, tickInterval: 10, allowDecimals: false },
                legend: {
                    enabled: true, labelFormatter: function () {
                        var total = 0;
                        for (var i = this.yData.length; i--;) { total += this.yData[i]; };
                        return this.name + '- Total: ' + total;
                    } },
                plotOptions: {
                    series: {
                        stacking: 'normal',
                        borderWidth: 0,
                        dataLabels: { enabled: true },
                        pointPadding: .9,
                        groupPadding: 1
                    }
                },
                colors: Object.values(dosing_colors)
                , //[ '#e07c3e', '#982568'],
                series: OPT_dosing
            });





            // barchart_3 data  
            var PT_PRIM_EXYN__count: any = hospitalStayData.reduce((acc, record) => {
                record.items.forEach(item => {
                    if (item.itemName === "PT_PRIM_EXYN") {
                        acc[item.itemValue] = (acc[item.itemValue] || 0) + 1;
                    }
                });
                return acc;
            }, {});

            const treatment_ticks: number = Math.round(Object.values(PT_PRIM_EXYN__count).reduce((a: number, b: number) => a + b, 0) as number / 4);
            

            // Highcharts barchart_3
            Highcharts.chart('opt_barchart_3', {
                chart: { type: 'bar', borderWidth: 1, borderColor: '#000000' },
                title: { text: 'Enrollment by Treatment Status' },
                xAxis: { type: 'category', allowDecimals: false, title: { text: '' }, labels: { enabled: false } }, //categories: ['Yes', 'No'] },
                yAxis: {
                    title: { text: 'Count' },
                    tickInterval: treatment_ticks,
                    allowDecimals: false
                },
                tooltip: {
                    formatter: function () {
                        return '<b>' + this.series.name + '</b>: ' + this.y;
                    }
                },
                series: [
                    {
                        name: 'Pharmacologically Treated',
                        data: [{ y: PT_PRIM_EXYN__count['1'] || 0 }],
                        color: '#982568'
                    },
                    {
                        name: 'NOT Pharmacologically Treated',
                        data: [{ y: PT_PRIM_EXYN__count['2'] || 0 }],
                        color: '#532565'
                    }
                ],
                caption: "Total number may not add to total enrolled."
            });
            // var bar_colors = {'Finnegan':  '#eecdcb', 'ESC': '#532565'};
            // console.log(Object.values(bar_colors))



            // Piechart data

            var race_decode = {
                '1': 'Black', '2': 'American Indian or Alaskan Native', '3': 'Native Hawaiian or Other Pacific Islander',
                '4': 'White', '5': 'Asian', '6': 'Unknown', '7': 'More than one race selected'
            }
            var race_array = enrollmentData.map(record => record.items
                .filter(i => i.itemName.startsWith('DM_RACE___')
                    && i.itemValue === '1')
                .map(i => i.itemName))
            // .map(i => i.split('___')[1]))
            var race_array2 = enrollmentData.map(record => {
                var races = record.items
                    .filter(i => i.itemName.startsWith('DM_RACE___') && i.itemValue === '1')
                    .map(i => i.itemName)
                    .map(i => i.split('___')[1]);
                return races.length > 1 ? '7' : races[0]; //parseInt(7) : parseInt(races[0]);
            });



            var eth_vals = ['Hispanic or Latino', 'Not Hispanic or Latino', 'Unknown']
            var ethnicity_array = enrollmentData.reduce((acc, record) => [
                ...acc,
                ...record.items
                    .filter(item => item.itemName.startsWith('DM_ETHNI'))
                    .map(item => item.itemValue)
            ], []);

            const counts1: any = race_array2.reduce((acc: any, val: any) => ({ ...acc, [val]: (acc[val] || 0) + 1 }), {});
            const counts2: any = ethnicity_array.reduce((acc: any, val: any) => ({ ...acc, [val]: (acc[val] || 0) + 1 }), {});
            const decoded_counts1: any = Object.entries(counts1).reduce((acc: any, [key, value]: any) => ({ ...acc, [race_decode[key]]: value }), {});
            const decoded_counts2: any = Object.entries(counts2).reduce((acc: any, [key, value]: any) => ({ ...acc, [eth_vals[key - 1]]: value }), {});    // -1!
            var pie_data1: any = Object.entries(decoded_counts1).map(([name, y]) => ({ name, y }));
            var pie_data2: any = Object.entries(decoded_counts2).map(([name, y]) => ({ name, y }));

            // Highcharts piecharts

            var pie_size = 169;

            Highcharts.chart('pie_chart_1', {
                chart: { type: 'pie', borderWidth: 1, borderColor: '#000000' },
                title: { text: 'Race Distribution', y: 100 },
                series: [{ data: pie_data1, showInLegend: true }],
                legend: {
                    enabled: false
                    //floating: true, //x:-200,
                    //layout: 'horizontal', align: 'middle', verticalAlign: 'bottom'
                },
                colors: Object.values(off_colors),
                plotOptions: { pie: { size: pie_size } },
                tooltip: { formatter: function () { return '<b>' + this.point.name + '</b>: ' + this.y + ' (' + Math.round(this.point.percentage) + '%)'; } }
            })

            Highcharts.chart('pie_chart_2', {
                chart: { type: 'pie', borderWidth: 1, borderColor: '#000000' },
                title: { text: 'Ethnicity Distribution', y: 100 },
                series: [{ data: pie_data2, showInLegend: true }],
                legend: {
                    enabled: false
                    //floating: true, //x:-100,
                    //layout: 'horizontal', align: 'middle', verticalAlign: 'bottom'
                },
                colors: Object.values(off_colors).filter((val, idx) => idx % 3 == 1),
                plotOptions: { pie: { size: pie_size } },
                tooltip: { formatter: function () { return '<b>' + this.point.name + '</b>: ' + this.y + ' (' + Math.round(this.point.percentage) + '%)'; } }
            })
        });
	}
}